import { render, staticRenderFns } from "./DlgCertModuleRoot.vue?vue&type=template&id=b54b7a30&scoped=true&lang=html&"
import script from "./DlgCertModuleRoot.vue?vue&type=script&lang=js&"
export * from "./DlgCertModuleRoot.vue?vue&type=script&lang=js&"
import style0 from "./DlgCertModuleRoot.vue?vue&type=style&index=0&id=b54b7a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54b7a30",
  null
  
)

export default component.exports